import React from 'react';
import { ArrowRight } from 'lucide-react';

const DashboardViewAllButton = ({ onClick, label = 'View all', className = '' }) => (
  <button type="button" className={`btn btn-sm d-flex align-items-center gap-1 fw-semibold text-white ${className}`} style={{ borderRadius: 20, border: 'none', padding: '6px 14px', background: 'linear-gradient(135deg,#0d5962,#1a767e)', boxShadow: '0 2px 8px rgba(26,118,126,.35)' }} onClick={onClick}>
    {label} <ArrowRight size={13} />
  </button>
);

export default DashboardViewAllButton;
